import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";

export default makeStyles<Theme>((theme) =>
  createStyles({
    alert: {
      marginBottom: theme.spacing(2),
    },
  })
);
